











































import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import Input from '@/components/Input.vue';
import { BottomWrapper } from '../BottomWrapper.vue';

import * as PleasedApi from '@/common/api/api.pleased';
import * as PleasedModel from '@/common/api/models.pleased';
import waiting from '@/components/loading/waiting';
import { analytics } from '@/common/gaHelper';
import { ConnectRequestEvent } from '@/common/types';

const userModule = namespace('user');

@Component({
  components: {
    Input,
    BottomWrapper,
  },
  directives: {
    waiting,
  },
})
export default class ContactOptions extends Vue {
  @Prop({ default: () => ({ subject: '', description: '', email: '' }) }) readonly requestInfo!: { subject: string, description: string, email: string };
  @Prop({ default: () => ({
    showCall: true,
    showLiveChat: true,
  }) }) readonly showLoggedInOptions!: { showCall: boolean, showLiveChat: boolean, showOpenRequest: boolean };

  @Prop(Boolean) readonly showAddComment!: boolean;
  @Prop({ default: () => [] }) readonly userSelections!: {message: string; timestamp: string}[]

  @Prop({ default: () => [] }) readonly openRequestFields!: PleasedModel.TicketField[];

  loading = false;
  queuePosition = 0;

  errInfo = {
    isErr: false,
    message: '',
  };

  voiceChatAgentsOnline = false;

  @userModule.State('isLogin') isLogin!: boolean;

  get queueMsg () {
    // https://opennetltd.atlassian.net/browse/PLS-652
    // 1. Only Live Chat
    const { queuePosition = 0 } = this;
    if (this.showLiveChat && !this.showCall && !this.showOpenRequest) {
      return this.$t('page.connect.message.only_chat', { queuePosition });
      // return `There are ${this.queuePosition} customers waiting to chat with our agents. To join the queue, click the Live Chat button. We will assist you as soon as we can.`;
    }

    // 2. Live Chat + Call
    if (this.showLiveChat && this.showCall && !this.showOpenRequest) {
      return this.$t('page.connect.message.chat_call', { queuePosition });
      // return `There are ${this.queuePosition} customers waiting to chat with our agents. To join the queue, click the Live Chat button. You can also talk to our agents by clicking the Call button and we will assist you as soon as we can.`;
    }

    // 3.  Live Chat + Open Requests
    if (this.showLiveChat && !this.showCall && this.showOpenRequest) {
      return this.$t('page.connect.message.chat_ticket', { queuePosition });
      // return `There are ${this.queuePosition} customers waiting to chat with our agents. To join the queue, click the Live Chat button. You can also reach out to us by opening a request and we will get back to you as soon as we can.`;
    }

    // 4 Live Chat + Open Requests + Call
    if (this.showLiveChat && this.showCall && this.showOpenRequest) {
      return this.$t('page.connect.message.all', { queuePosition });
      // return `There are ${this.queuePosition} customers waiting to chat with our agents. To join the queue, click the Live Chat button. You can also reach out to us by opening a request or calling us, we will assist you as soon as we can`;
    }

    // 5 Open Request:
    if (!this.showLiveChat && !this.showCall && this.showOpenRequest) {
      return this.$t('page.connect.message.only_ticket', { queuePosition });
      // return 'Reach out to us by opening a request and we will get back to you as soon as we can.';
    }

    // 6 Open Request + Call
    if (!this.showLiveChat && this.showCall && this.showOpenRequest) {
      return this.$t('page.connect.message.call_ticket');
      // return 'To speak to one of our support agents, click the Call button. You can also reach out to us by opening a request or calling us, we will assist you as soon as we can.';
    }

    // Only calls
    if (this.showLoggedInOptions.showCall && !this.voiceChatAgentsOnline) {
      return this.$t('page.connect.message.only_call_no_agent_online');
      // return 'We apologize as there are no agents online right now. Please try again in sometime.';
    }

    return this.$t('page.connect.message.none');
    // return 'We are experiencing some technical difficulties, Please try again later.';
  }
  get showLiveChat () {
    return this.showLoggedInOptions.showLiveChat;
  }
  get showCall () {
    return this.voiceChatAgentsOnline && this.showLoggedInOptions.showCall;
    // TODO: [voice dev]
  }
  get showOpenRequest () {
    return this.isLogin && !this.showAddComment && this.showLoggedInOptions.showOpenRequest;
  }

  async created () {
    this.loading = true;
    // TODO: [Sportybet]
    const voiceChatAgentsRequest = this.showLoggedInOptions.showCall ? PleasedApi.areVoiceChatAgentsOnline() : Promise.resolve(false);
    try {
      const [queue, voiceAgentOnline] = await Promise.all([PleasedApi.getQueuePosition(), voiceChatAgentsRequest]);
      this.queuePosition = queue.position;

      this.voiceChatAgentsOnline = voiceAgentOnline;
    } catch {}
    this.loading = false;
  }

  select (id: number) {
    if (id === 1) {
      analytics.liveChat();
      const $event: ConnectRequestEvent = {
        type: 'chat',
        payload: {
          description: this.requestInfo.description,
        },
      };
      this.$emit('connect:request', $event);
    } else if (id === 2) {
      analytics.call();

      const $event: ConnectRequestEvent = {
        type: 'voice',
        payload: {
          description: this.requestInfo.description,
          query: this.requestInfo.subject || '',
        },
      };
      this.$emit('connect:request', $event);
    } else if (id === 3) {
      analytics.createTicket();
      this.loading = true;
      PleasedApi.createTicket({
        subject: this.requestInfo.subject,
        description: this.requestInfo.description,
        recipientAddress: this.requestInfo.email,
        ticketFields: this.openRequestFields,
        userSelections: this.userSelections.map(({ timestamp, message }) => ({ message, createdAt: `${timestamp}` })),
      })
        .then(res => {
          const $event: ConnectRequestEvent = {
            type: 'openRequest',
            payload: {
              ticketId: res.id,
            },
          };
          this.$emit('connect:request', $event);
        })
        .catch(e => {
          const error: Error = e;
          this.errInfo.isErr = true;
          this.errInfo.message = error.message;
        })
        .finally(() => {
          this.loading = false;
        });
    } else if (id === 4) {
      const $event: ConnectRequestEvent = {
        type: 'addComment',
        payload: {},
      };
      this.$emit('connect:request', $event);
    }
  }
  cleanErr () {
    this.errInfo.isErr = false;
    this.errInfo.message = '';
  }
}
